import React from 'react';
import './EventButton.scss';
import { Icon } from 'antd';

interface IProps {
  iconType: string;
  style: string;
  onClick: () => void;
}

const EventButton: React.SFC<IProps> = ({
  iconType,
  style,
  onClick,
  children,
}) => (
  <button className={ `event-button ${ style }` } onClick={ onClick }>
    <div className='left'>
      <Icon type={ iconType } />
    </div>
    <div className='right'>
      { children }
    </div>
  </button>
);

export default EventButton;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/EventButton/EventButton.tsx